import { render, staticRenderFns } from "./SubmitSuccessMobileModal.vue?vue&type=template&id=35abdcae&scoped=true"
import script from "./SubmitSuccessMobileModal.vue?vue&type=script&lang=js"
export * from "./SubmitSuccessMobileModal.vue?vue&type=script&lang=js"
import style0 from "./SubmitSuccessMobileModal.vue?vue&type=style&index=0&id=35abdcae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35abdcae",
  null
  
)

export default component.exports